import React from 'react';

/**
 * Sidebar list of branded reports (Drummond users only).
 *
 * Order: Drummond (house) first, then tailored clients (those with access to a
 * tailored portfolio), then a spacer, then the remaining clients alphabetically.
 * Selecting one loads that brand's white-labelled version of the month's report.
 */
const BrandList = ({ brands, selectedDomain, onSelect }) => {
  const byName = (a, b) => a.name.localeCompare(b.name);
  const clients = (brands || []).map((b) => ({
    domain: b.domain,
    name: b.company_name || b.domain,
    code: b.domain,
    tailored: !!b.tailored,
  }));

  const tailored = clients.filter((c) => c.tailored).sort(byName);
  const rest = clients.filter((c) => !c.tailored).sort(byName);

  const topGroup = [{ domain: '_default', name: 'Drummond', code: 'House' }, ...tailored];

  const renderItem = (it) => (
    <button
      key={it.domain}
      type="button"
      className={`portfolio-item ${selectedDomain === it.domain ? 'active' : ''}`}
      onClick={() => onSelect(it.domain)}
      title={it.name}
    >
      <span className="portfolio-name">{it.name}</span>
      <span className="portfolio-code">{it.code}</span>
    </button>
  );

  return (
    <div className="portfolio-list">
      <h4 className="list-heading">Reports</h4>
      {topGroup.map(renderItem)}
      {rest.length > 0 && <div className="ip-brand-spacer" />}
      {rest.map(renderItem)}
    </div>
  );
};

export default BrandList;
